<template>
    <div class="help">
        <Bar title="帮助/反馈" @goBack="goBack" />
        <h4>{{detail.title}}</h4>
        <div v-html="detail.content"></div>
    </div>
</template>
<script>
import Bar from '../components/bar.vue'
export default {
    name: 'vipCoachHelpDetail',
    components: {
        Bar
    },
    data () {
        return {
            detail: {}
        }
    },
    methods: {
        // 返回上一页
        goBack () {
            this.$router.back()
        },
        getData () {
            const { id } = this.$route.query
            this.$api.getCoachHelpDetail({
                id
            }).then(res => {
                if (res.status) {
                    this.detail = res.result
                }
            })
        }
    },
    mounted () {
        this.getData()
    }
}
</script>
<style lang="scss" scoped>
* {
    box-sizing: border-box;
}
.help{
    padding: 10px 15px;
    background-color: #F3F4FB;
    line-height: 24px;
    h4{
        color:#333;
        font-size: 18px;
    }
}
</style>
